const isIOS = /iPad|iPhone|iPod/.test(navigator?.platform ?? '')

/*
  smooth scrollIntoView with scroll snapping fails in iOS 16 when browser chrome is hidden:
  https://bugs.webkit.org/show_bug.cgi?id=245722
  */
export const useIOSScrollfix = isIOS

// Scroll snapping performs poorly on older iOS versions (<=14.0)
const hasBreakingScrollSnapIssues = isIOS && !CSS.supports('aspect-ratio', '1 / 1')

export const scrollSnapSupported = !hasBreakingScrollSnapIssues
